interface ChowsAndBlogsCitationsProps {
  citation: string[] | any;
}

function ChowsAndBlogsCitations({ citation }: ChowsAndBlogsCitationsProps) {
  return (
    <div>
      <a
        href={citation.link}
        target="_blank"
        rel="noopener noreferrer"
        className="cursor-pointer text-left block link_text_color hover:underline"
      >
        {citation.title} <i> by {citation.author}</i>
      </a>
    </div>
  );
}

export default ChowsAndBlogsCitations;
